import { render, staticRenderFns } from "./StoriesComments.vue?vue&type=template&id=6e10729b&lang=html"
import script from "./StoriesComments.vue?vue&type=script&lang=js"
export * from "./StoriesComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports